import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

interface TrustScoreTagProps extends ComponentPropsWithoutRef<'span'> {
  score?: number | string;
}

export const getTrustScoreLabel = (trustScore?: string | number | null) => {
  const trustCodeNumber = Number(trustScore);

  if (trustScore === null || Number.isNaN(trustCodeNumber)) {
    return 'N/A';
  }

  if (trustCodeNumber < 1.3) {
    return 'Low';
  }

  if (trustCodeNumber < 2.3) {
    return 'Medium';
  }

  return 'High';
};

const TrustScoreTag = ({ className, score, ...props }: TrustScoreTagProps) => {
  const label = getTrustScoreLabel(score);

  return (
    <span
      className={classNames(
        'inline-flex justify-center items-center rounded-full h-5 t-body4 px-2.5',
        {
          Low: 'bg-red-600 text-neutral-50',
          Medium: 'bg-yellow-600 text-neutral-50',
          High: 'bg-green-600 text-neutral-50',
          'N/A': '',
        }[label],
        className,
      )}
      {...props}
      data-qa="trust-review-score"
    >
      {label}
    </span>
  );
};

export default TrustScoreTag;
